import Blogs2 from "../../../components/blogs/Blogs2";

import PageTitle2 from "../../../components/blogs/PageTitle2";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import React from "react";

import MetaComponent from "../../../components/common/MetaComponent";
const metadata = {
  title: "Blog Grid || Homelengo - Real Estate Reactjs Template",
  description: "Homelengo - Real Estate Reactjs Template",
};
export default function BlogGridPage() {


  const [MetaTitle, setMetaTitle] = React.useState("Blogs || AskMeRealty - Real Estate Services");
  const [MetaDescription, setMetaDescription] = React.useState("AskMeRealty - Stay updated with the latest news, insights, and trends in the real estate industry. Our blog covers a wide range of topics to help you make informed decisions about buying, selling, renting, and managing properties.");
  const [MetaKeywords, setMetaKeywords] = React.useState("Our Blogs, AskMeRealty, Real Estate Blogs, Property Buying Tips, Property Selling Advice, Renting Guides, Property Management Insights, Real Estate Market Trends");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <PageTitle2 setMetaTitle={setMetaTitle} setMetaDescription={setMetaDescription} setMetaKeywords={setMetaKeywords} setMetaImage={setMetaImage} />
      <Blogs2 />
      <Footer1 />
    </>
  );
}
